import {ButtonBase} from '@mui/material';
import {styled} from '@mui/material/styles';

export const StyledButton = styled(ButtonBase)(({theme}) => ({
	width: '100%',
	borderRadius: theme.spacing(1.5),
	padding: theme.spacing(1),
	border: `1px solid ${theme.palette.divider}`,
	display: 'flex',
	flexDirection: 'column',
	backgroundColor: theme.palette.background.paper,
}));
